// extracted by mini-css-extract-plugin
export default {"Positioner":"YuJaTooltip_Positioner__HPNwI","Popup":"YuJaTooltip_Popup__7oR6k","Arrow":"YuJaTooltip_Arrow__7W2sc"};